import React, { FC, useEffect, useState } from 'react';
import { Form, Input, Button, Modal, Space, Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch, CombinedStates } from '../../../core/types';
import { updateUser, forgotPassword } from '../../../core/user/userApi';
import './settingsForm.scss';
import { FinishedFailedProps, valuesProps } from './types';
import { UserData } from '../../../core/user/types';

const LoginForm = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigation = useNavigate();
    const {
        isFetching,
        userData,
    } = useSelector((state:CombinedStates) => state.user);

    const [
        forgetPasswordModalVisible,
        setForgetPasswordModalVisible,
    ] = useState(false);

    const [form] = Form.useForm();

    const onFinish = (values: UserData) => {
        dispatch(updateUser(values));
    };

    // const onFinishFailed = (errorInfo: FinishedFailedProps) => {
    //     const { errorFields } = errorInfo;
    //     form.scrollToField(errorFields[0]?.name);
    // };

    const onFinishFailed:FC<FinishedFailedProps> = ({ errorFields }) => {
        form.scrollToField(errorFields[0]?.name);
        return null;
    };

    const handleForgotFinish = (values: valuesProps) => {
        dispatch(forgotPassword({
            email: values.email,
        }));

        // setTimeout(() => { setForgetPasswordModalVisible(false); }, 1500);

    };

    const forgotFinishFailed = ({ errorFields }:FinishedFailedProps) => {
        form.scrollToField(errorFields[0]?.name);
    };

    return (
        <>
            <div className="form">
                <h3 className="form-title h-1">Nustatymai</h3>
                <Form
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                        email: userData?.email,
                        first_name: userData?.first_name,
                        last_name: userData?.last_name,
                    }}
                    layout="vertical">
                    <Row>
                        <Col span={8}>
                            <Form.Item
                                label="El. pašto adresas"
                                name="email"
                                rules={[{ type: 'email', message: 'Įvestas netinkamas el. pašto adresas!' }, { required: true, message: 'Prašome įvesti savo el. paštą' }]}>
                                <Input size="large" placeholder="Įrašykite savo el. paštą" disabled />
                            </Form.Item>

                            <Form.Item
                                label="Vardas"
                                name="first_name"
                                rules={[{ required: true, message: 'Įveskite vardą.' }]}>
                                <Input size="large" placeholder="Įveskite vardą" />
                            </Form.Item>

                            <Form.Item
                                label="Pavardė"
                                name="last_name"
                                rules={[{ required: true, message: 'Įveskite pavardę.' }]}>
                                <Input size="large" placeholder="Įveskite pavardę" />
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    size="large"
                                    htmlType="submit"
                                    block
                                    className={`mt-3 ${isFetching ? '' : 'primary-btn-style'}`}
                                    loading={isFetching}>
                                    Atnaujinti
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div className="text-center">
                    <Button onClick={() => setForgetPasswordModalVisible(true)} type="link" className="button-link mlp-25" href="#">
                        Pamiršote slaptažodį?
                    </Button>
                </div>
            </div>

            <Modal centered width={540} footer={null} open={forgetPasswordModalVisible} onOk={() => { setForgetPasswordModalVisible(false); }} onCancel={() => { setForgetPasswordModalVisible(false); }}>
                <h4 className="h-3 title-text-md  text-center">Atstatyti slaptažodį</h4>
                <div className="form-wrap">
                    <Form onFinish={handleForgotFinish} onFinishFailed={forgotFinishFailed} layout="vertical">
                        <Form.Item label="El. paštas" name="email" rules={[{ type: 'email', message: 'Įvestas neteisinga El. paštas!' }, { required: true, message: 'Prašome įvesti savo el. paštą' }]}>
                            <Input size="large" />
                        </Form.Item>
                        <Space>
                            <Button type="primary" htmlType="submit" className="wide" loading={isFetching}>
                                Atnaujinti slaptažodį
                            </Button>
                            <Button className="link-green btn-empty underlined" onClick={() => { setForgetPasswordModalVisible(false); }}>
                                Atšaukti
                            </Button>
                        </Space>
                    </Form>
                </div>
            </Modal>
        </>
    );
};

export default LoginForm;
